<template>
    <div id="permission_list">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                <div class="page-name">Permission List
                    <router-link class="btn btn-success waves-effect pull-right" v-bind:to="{name: 'PermissionCreate'}" >Add</router-link>
                </div>
                <div class="admin-page-content customer-detail">
                    <section class="internal-container">
                        <div class="container">
                            <vue-good-table
                                ref="listPermissionTable"
                                mode="remote"
                                title="Permission"
                                @on-page-change="onPageChange"
                                @on-selected-rows-change="selectionChanged"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange"
                                :totalRows="totalRecords"
                                :columns="columns"
                                :rows="rows"
                                :pagination-options="{
                                    enabled: true,
                                    position: 'both',
                                    perPage: perPage,
                                    dropdownAllowAll: false,
                                }"
                                :search-options="{
                                enabled: false,
                                }">

                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                            <router-link title="Edit Permission" class="glyphicon glyphicon-edit" v-bind:to="{name: 'PermissionEdit',params:{id:props.row.id}}"></router-link>
                                        </div>
                                        <div v-else>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>

                                <!-- <div slot="selected-row-actions">
                                    <button id="deletePermissionBtn" v-on:click.prevent="PermissionDelete" class="btn btn-success waves-effect">Delete</button>
                                </div> -->
                            </vue-good-table>
                        </div>
                    </section>
                </div>
            </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <admin-footer></admin-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import Footer from '@/components/Footer';


import {commonMixins} from '../mixins/commonMixins';


import EventBus from "././event-bus";

Vue.component("app-footer", Footer);

    export default {
        name: "PermissionList",
        mixins:[commonMixins],
        data: () => ({
             permissions: [],
            cantAccessPage: "",
            firstLoad: 0,
            columns: [
                {
                    label: 'Permission Name',
                    field: 'name',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Permission Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Module Name',
                    field: 'module_name',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Module Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Guard Name',
                    field: 'guard_name',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Guard Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created Date',
                    field: 'created_at',
                    html: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Actions',
                    field: 'action',
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'created_at',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            loading:false
        }),
        watch:{
            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_permission') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            //self.loadPermissions();
            self.getPermissions();
        },
        methods: {

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadPermissions();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadPermissions();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.module_name || filters.guard_name || filters.created_at) {
                    this.loadPermissions();
                }
            },
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadPermissions();
            },
            loadPermissions() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/permission/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

        }
    };
</script>



// WEBPACK FOOTER //
// src/components/PermissionList.vue